import { useEffect } from "react";

import { recordAdClick } from "@/lib/ads.functions";

const PAID_SOURCES = ["google", "adwords", "bing", "facebook", "instagram", "meta"];

/**
 * Registra, uma vez por visita, os acessos que chegaram de anúncios pagos.
 * Guarda o IP no banco para permitir identificar cliques repetidos de concorrentes.
 */
export function AdClickTracker() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid") ?? params.get("gbraid") ?? params.get("wbraid");
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");

    const isPaid =
      Boolean(gclid) ||
      (utmSource ? PAID_SOURCES.includes(utmSource.toLowerCase()) : false) ||
      (utmMedium ? /cpc|ppc|paid/i.test(utmMedium) : false);

    if (!isPaid) return;

    const key = `chavel_ad_click:${gclid ?? `${utmSource}-${params.get("utm_campaign") ?? ""}`}`;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, "1");
    } catch {
      // sessionStorage bloqueado: segue registrando
    }

    void recordAdClick({
      data: {
        gclid,
        utmSource,
        utmMedium,
        utmCampaign: params.get("utm_campaign"),
        utmTerm: params.get("utm_term") ?? params.get("keyword"),
        landingPage: window.location.pathname + window.location.search,
        referrer: document.referrer || null,
      },
    }).catch((error) => console.error("Não foi possível registrar o clique do anúncio:", error));
  }, []);

  return null;
}
